import { render, staticRenderFns } from "./payOther.vue?vue&type=template&id=748e5212&scoped=true&"
import script from "./payOther.vue?vue&type=script&lang=js&"
export * from "./payOther.vue?vue&type=script&lang=js&"
import style0 from "./payOther.vue?vue&type=style&index=0&id=748e5212&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748e5212",
  null
  
)

export default component.exports